import { Navigate, useParams } from 'react-router-dom'

import { ROUTES, STORAGE_KEYS } from 'src/constants'

export const InviteFriendRedirect = () => {
  const { referralId } = useParams()

  if (referralId) {
    try {
      localStorage.setItem(STORAGE_KEYS.REFERRAL_ID, referralId)
    } catch (error) {
      console.error(error)
    }
  }

  return <Navigate to={ROUTES.REGISTER} replace />
}
